import { gql } from '@apollo/client';

// 会話更新のサブスクリプション
export const ON_CONVERSATION_UPDATED = gql`
  subscription OnConversationUpdated($sessionId: ID!) {
    onConversationUpdated(sessionId: $sessionId) {
      counter
      userContent
      aiContent
      aiParams
      aiGuide
      status
      userAudioPath
      aiAudioPath
      createdAt
      updatedAt
    }
  }
`;

export const ON_SESSION_UPDATED = gql`
  subscription OnSessionUpdated($sessionId: ID!) {
    onSessionUpdated(sessionId: $sessionId) {
      sessionId
      status
      updatedAt
    }
  }
`;
